'use strict';

var createElement = require('@cloudcmd/create-element');

var query = require('./query');

module.exports = function (title, parent) {
  var titleEl = query('title');

  if (titleEl) {
    query('title-text').textContent = title;
    return;
  }

  var el = createElement('div', {
    className: 'modal-title',
    dataName: 'modal-title',
    parent: parent
  });
  createElement('span', {
    parent: el,
    textContent: title,
    className: 'modal-title-text',
    dataName: 'modal-title-text'
  });
};